<template>
    <div>
        <b-form>
            <!-- THE ALERT MESSAGE FROM CALCULATION -->
            <!-- ATTEMPTED TO IMPLEMENT MULTIPLE ALERT MESSAGES AS BELOW BUT THE CALCULATIUON HAS MANY SCENARIO SO NEED TO AVOID TO PREVENT REGRESSIONS -->
            <b-alert :show="!_.isEmpty(alertMessage)" variant="warning">
                <i class="cus-error"></i>
                {{ alertMessage }}
            </b-alert>

            <!-- THE ALERT MESSAGE FOR PROVIDER CLINIC AND OTHERS -->
            <b-alert
                v-for="(alertMessage, idx) in alertMessages"
                :class="idx < alertMessages.length - 1 ? 'mb-2' : ''"
                :key="idx"
                :show="showAlert"
                variant="warning"
            >
                <div>
                    <i class="cus-error"></i>
                    <span v-html="alertMessage"></span>
                </div>
            </b-alert>
            <b-form-group
                v-if="isNew || !isInvoice"
                label-for="item_id"
                label-cols="4"
                label="Item:"
            >
                <vet-select
                    id="item"
                    ref="select-item"
                    placeholder="Item (required)"
                    name="item"
                    module="item"
                    v-model="data.item"
                    v-validate="'required'"
                    :disabled="isDisabled"
                    :selectProps="vetItemProps"
                    :class="{
                        'border-danger': errors.has('item'),
                        rounded: true
                    }"
                    :isOptionBold="true"
                />
            </b-form-group>

            <b-form-group
                v-else
                label-for="item"
                :label-cols="4"
                label="Item:"
                class="item"
            >
                <div class="col-form-label">
                    {{ data.itemName || "" }}
                </div>
            </b-form-group>

            <b-form-group
                label-for="patient"
                label="Patient:"
                label-cols="4"
                v-if="showPatientField"
            >
                <template v-if="isInvoice && (isNew || isDuplicate)">
                    <!-- FOR INVOICE : NOT EDITABLE, CAN BE SELECTED ONLY WHEN NEW OR DUPLICATE -->
                    <v-select
                        v-show="isItemAllowMultiplePatient"
                        id="patient"
                        :placeholder="`Patient name (${
                            data.isHasRecordPage == CREATERECORD
                                ? 'required'
                                : 'optional'
                        })`"
                        label="name"
                        name="patient"
                        multiple
                        :selectable="selectablePatient"
                        v-model="data.patients"
                        v-validate="{
                            required: data.isHasRecordPage == CREATERECORD
                        }"
                        :class="{ 'border-danger': errors.has('patient') }"
                        aria-placeholder="true"
                        :options="patientOptionsFilter"
                        :disabled="isDisabled"
                    />
                    <v-select
                        v-show="!isItemAllowMultiplePatient"
                        id="patient"
                        :placeholder="`Patient name (${
                            data.isHasRecordPage == CREATERECORD
                                ? 'required'
                                : 'optional'
                        })`"
                        label="name"
                        name="patient"
                        v-model="data.patients[0]"
                        v-validate="{
                            required: data.isHasRecordPage == CREATERECORD
                        }"
                        :class="{ 'border-danger': errors.has('patient') }"
                        aria-placeholder="true"
                        :options="patientOptions"
                        :disabled="isDisabled"
                    />
                </template>
                <!-- FOR ESTIMATE : OPTIONAL & EDITABLE -->
                <v-select
                    v-else-if="!isInvoice"
                    id="patient"
                    :placeholder="`Patient name (optional)`"
                    label="name"
                    name="patient"
                    v-model="data.patients[0]"
                    aria-placeholder="true"
                    :options="patientOptions"
                />
                <div class="col-form-label" v-else>
                    <span
                        v-b-tooltip.hover.top
                        title="The patient field cannot be edited. There is the duplicate item function as an alternative."
                    >
                        {{ patientName }}
                    </span>
                </div>
            </b-form-group>
            <b-form-group
                class="quantity"
                label-for="quantity"
                :label-cols="4"
                label="Quantity:"
            >
                <div class="form-inline">
                    <template v-if="isInvoice">
                        <b-form-input
                            id="quantity"
                            name="quantity"
                            type="number"
                            placeholder="Quantity (required)"
                            class="col mr-auto"
                            :value="data.quantity"
                            :disabled="isQuantityDisabled"
                            :readonly="isDisabled || isSelectVetsource"
                            v-validate="'required|min_value:0|decimal:3'"
                            :class="{
                                'border-danger': errors.has('quantity')
                            }"
                            @input="debounceQuantity"
                            @change="immediateQuantity"
                            @wheel="event => event.target.blur()"
                        ></b-form-input>
                        <span class="ml-1 col">
                            {{ data.uomLabel ? data.uomLabel : "" }}
                        </span>
                    </template>
                    <template v-else>
                        <b-form-input
                            id="min-quantity"
                            name="min-quantity"
                            placeholder="Low (required)"
                            class="col-3"
                            :value="data.minQuantity"
                            v-validate="'required|min_value:0|decimal:3'"
                            :class="{
                                'border-danger': errors.has('min-quantity')
                            }"
                            :readonly="isDisabled"
                            @input="debounceMinQuantity"
                            @change="immediateMinQuantity"
                            @wheel="event => event.target.blur()"
                        ></b-form-input>
                        <span class="col-1 mr-1">-</span>
                        <b-form-input
                            id="max-quantity"
                            name="max-quantity"
                            placeholder="High (optional)"
                            class="col-3"
                            :value="data.maxQuantity"
                            v-validate="
                                'decimal:3' +
                                (data.maxQuantity
                                    ? data.maxQuantity == 0
                                        ? '|min_value:0.001'
                                        : `|min_value:${data.minQuantity}`
                                    : '')
                            "
                            :class="{
                                'border-danger': errors.has('max-quantity')
                            }"
                            :readonly="isDisabled"
                            @input="debounceMaxQuantity"
                            @change="immediateMaxQuantity"
                            @wheel="event => event.target.blur()"
                        ></b-form-input>
                        <span class="col-3">
                            {{ data.uomLabel ? data.uomLabel : "" }}
                        </span>
                    </template>
                    <dosage
                        :data="{
                            id:
                                data.item_type != ITEMTYPES.TYPES.TYPE_LAB &&
                                data.item
                                    ? data.item.id
                                    : null
                        }"
                        :isMultiplePatients="data.isMultiplePatient"
                        :patients="data.patients"
                        :weight-data="weight"
                        :item-id="
                            data.item_type != ITEMTYPES.TYPES.TYPE_LAB &&
                            data.item
                                ? data.item.id
                                : null
                        "
                        target="quantity"
                        parent-id="createItemPage"
                        class="btn-sm ml-1"
                        style="position: absolute; right: 0;"
                        :container="null"
                    />
                </div>
            </b-form-group>

            <!-- VET-580 -->
            <b-form-group
                v-show="med_record_rad && isInvoice"
                :label-for="`send_to_device`"
                :label-cols="4"
                label="Send to Device:"
            >
                <b-form-select
                    v-model="data.send_to_device"
                    name="send_to_device"
                    class="form-control"
                    :options="sendToDeviceOptions"
                    :disabled="isSelectVetsource"
                    :label="'text'"
                ></b-form-select>
            </b-form-group>

            <b-form-group
                class="lab-record source"
                v-if="
                    data.item_type === ITEMTYPES.TYPES.TYPE_LAB &&
                    originalSourcesLength &&
                    originalSourcesLength > 1 &&
                    isInvoice
                "
                :label-for="`source`"
                :label-cols="4"
                label="Source:"
            >
                <b-form-select
                    v-model="data.source"
                    :options="sourceOptions"
                    :disabled="isSelectVetsource"
                    class="form-control"
                    name="source"
                ></b-form-select>
            </b-form-group>

            <!-- in Patient > create record , isHeskaCloud & isDisabledSendTo is when from patient > dashboard > lab-->
            <b-form-group
                class="lab-record send-to-lab"
                v-if="showSendToLab && isInvoice"
                label-class="font-weight-bold"
                :label-cols="4"
                id="send-to-lab"
                :label="sendToLabLabel"
            >
                <b-form-select
                    v-model="data.send_to"
                    name="send_to"
                    class="form-control"
                    :disabled="isSelectVetsource"
                >
                    <option :value="1">Yes</option>
                    <option :value="0">No</option>
                </b-form-select>
            </b-form-group>

            <b-form-group
                label-for="unit-price"
                :label-cols="4"
                :label="`Unit Price (${_currency}):`"
            >
                <div class="form-inline">
                    <template v-if="isInvoice">
                        <b-form-input
                            id="unit-price"
                            placeholder="Unit Price (required)"
                            name="unitPrice"
                            type="number"
                            class="col mr-auto"
                            v-validate="'required|decimal:2'"
                            :value="data.unitPrice"
                            :disabled="
                                !_hasAccess('billing.invoice.update.price')
                            "
                            :readonly="isDisabled || isSelectVetsource"
                            :class="{
                                'border-danger': errors.has('unitPrice')
                            }"
                            @input="debounceUnitPrice"
                            @change="immediateUnitPrice"
                            @wheel="event => event.target.blur()"
                        ></b-form-input>
                    </template>
                    <template v-else>
                        <b-form-input
                            id="min-unit-price"
                            placeholder="Unit Price (required)"
                            name="min-unit-price"
                            class="col-3"
                            v-validate="'required|decimal:2'"
                            :value="data.minUnitPrice"
                            @input="debounceMinUnitPrice"
                            @change="immediateMinUnitPrice"
                            :disabled="
                                !_hasAccess('billing.estimate.update.price')
                            "
                            :readonly="isDisabled"
                            :class="{
                                'border-danger': errors.has('min-unit-price')
                            }"
                        ></b-form-input>
                        <span class="col-1 mr-1">-</span>
                        <b-form-input
                            id="max-unit-price"
                            placeholder="Unit Price (optional)"
                            name="max-unit-price"
                            class="col-3"
                            v-validate="validationMaxUniPriceRules"
                            :value="
                                data.maxQuantity || data.maxUnitPrice != 0
                                    ? data.maxUnitPrice
                                    : null
                            "
                            @input="debounceMaxUnitPrice"
                            @change="immediateMaxUnitPrice"
                            :disabled="
                                !_hasAccess('billing.estimate.update.price')
                            "
                            :readonly="isDisabled"
                            :class="{
                                'border-danger': errors.has('max-unit-price')
                            }"
                        ></b-form-input>
                        <i
                            v-if="isPriceTier"
                            class="fa fa-info-circle pl-1"
                            v-b-tooltip.hover="{
                                placement: 'top',
                                title:
                                    'This item has a price tier set up. Changing the unit price will automatically check that the maximum unit price is higher than the minimum unit price.'
                            }"
                        ></i>
                    </template>
                </div>
            </b-form-group>

            <b-form-group label-for="fees" :label-cols="4" label="Fees:">
                <vet-select-fee
                    ref="vetSelectFee"
                    :disabled="
                        Number(data.item_type) ==
                            ITEMTYPES.TYPES.TYPE_OTHER_FEES ||
                        isDisabled ||
                        isSelectVetsource
                    "
                    :value="data.fees"
                    :is-display-price="true"
                    @input="val => (data.fees = val)"
                ></vet-select-fee>
            </b-form-group>

            <b-form-group label-for="discount" label="Discount:" label-cols="4">
                <select
                    id="discount"
                    name="discount"
                    class="form-control"
                    v-model="data.discountId"
                    v-validate="'required'"
                    :class="{
                        'border-danger':
                            errors.has('discount') ||
                            formError.includes('discount')
                    }"
                    :disabled="
                        (isInvoice
                            ? !_hasAccess('billing.invoice.update.discount')
                            : !_hasAccess(
                                  'billing.estimate.update.discount'
                              )) ||
                        isDisabled ||
                        isSelectVetsource
                    "
                >
                    <option
                        v-for="discount in discountOptions"
                        :key="discount.id"
                        :value="discount.id"
                    >
                        {{ discount.name }}
                    </option>
                </select>
            </b-form-group>

            <b-form-group
                v-show="isDiscountCustom"
                label-for="discount-amount"
                :label-cols="4"
                label="Discount Amount:"
            >
                <div class="form-inline">
                    <b-form-input
                        id="discountAmount"
                        placeholder="Discount (optional)"
                        name="discountAmount"
                        type="number"
                        v-validate="
                            'numericalWithDecimal|min_value:0|decimal:3'
                        "
                        :value="data.discountAmount"
                        :class="{
                            'border-danger': errors.has('discountAmount')
                        }"
                        :disabled="
                            isInvoice
                                ? !_hasAccess('billing.invoice.update.discount')
                                : !_hasAccess(
                                      'billing.estimate.update.discount'
                                  )
                        "
                        :readonly="isDisabled || isSelectVetsource"
                        @input="debounceDiscountAmount"
                        @change="immediateDiscountAmount"
                        @wheel="event => event.target.blur()"
                    ></b-form-input>
                    <select
                        id="discountType"
                        name="discountType"
                        class="col ml-3 form-control custom-select"
                        v-model="data.discountType"
                        :disabled="
                            (isInvoice
                                ? !_hasAccess('billing.invoice.update.discount')
                                : !_hasAccess(
                                      'billing.estimate.update.discount'
                                  )) ||
                            isDisabled ||
                            isSelectVetsource
                        "
                    >
                        <option :value="0">%</option>
                        <option :value="1">{{ _currency }}</option>
                    </select>
                </div>
            </b-form-group>

            <b-form-group
                v-if="showDiscountRange"
                label-for="discount-range"
                :label-cols="4"
                :label="`Discount Range (${_currency}):`"
            >
                <div class="form-inline">
                    <b-form-input
                        id="discount-min"
                        name="discount-min"
                        class="col-3"
                        :value="data.discountMin"
                        :disabled="true"
                    ></b-form-input>
                    <span class="col-1 mr-1">-</span>
                    <b-form-input
                        id="discount-max"
                        placeholder="Discount Max"
                        name="discount-max"
                        class="col-3"
                        :value="
                            data.maxQuantity ||
                            data.maxUnitPrice != 0 ||
                            data.discountMax != 0
                                ? data.discountMax
                                : null
                        "
                        :disabled="true"
                    ></b-form-input>
                </div>
            </b-form-group>

            <b-form-group
                label-for="price-per-tax"
                :label-cols="4"
                :label="`Price Pre-Tax (${_currency}):`"
            >
                <div class="col-form-label" v-if="isInvoice">
                    <div v-if="hideUnitPrice">
                        <i class="cus-error"></i>
                        <i>{{ hideUnitPrice }}</i>
                    </div>
                    <div v-else>
                        {{
                            this.data.total_item_price == 0
                                ? _toNumber(this.data.total_item_price, 2)
                                : this.data.total_item_price
                        }}
                    </div>
                </div>
                <div class="form-inline" v-else>
                    <b-form-input
                        id="total-min-item-price"
                        name="total-min-item-price"
                        class="col-3"
                        :value="data.total_item_price_min"
                        :disabled="true"
                    ></b-form-input>
                    <span class="col-1 mr-1">-</span>
                    <b-form-input
                        id="max-unit-price"
                        name="max-unit-price"
                        placeholder="Pre Tax Max"
                        class="col-3"
                        :value="
                            data.maxQuantity ||
                            (data.total_item_price_max != 0 &&
                                data.maxUnitPrice != 0)
                                ? data.total_item_price_max
                                : null
                        "
                        :disabled="true"
                    ></b-form-input>
                </div>
            </b-form-group>

            <b-form-group label="Taxes:" label-cols="4" label-for="taxes">
                <vet-select-tax
                    v-if="!isExcludedFromTaxes"
                    :disabled="isSelectVetsource"
                    ref="vetSelectTaxes"
                    :value="data.taxes"
                    @input="val => (data.taxes = val)"
                />
                <div v-else class="col-form-label">Tax Exempt</div>
            </b-form-group>

            <b-form-group
                label="Provider:"
                class
                label-cols="4"
                label-for="provider"
            >
                <v-select
                    id="provider"
                    ref="vselectProvider"
                    v-validate="`${isInvoice ? 'required' : ''}`"
                    v-model="data.provider"
                    name="provider"
                    :label="'name'"
                    aria-placeholder="true"
                    :placeholder="providerPlaceholder"
                    :class="{
                        'border-danger':
                            errors.has('provider') ||
                            formError.includes('provider')
                    }"
                    :options="providers"
                ></v-select>
            </b-form-group>

            <b-form-group
                label-for="poi"
                :label-cols="4"
                :label="`Print On ${isInvoice ? 'Invoice' : 'Estimate'}:`"
            >
                <select
                    id="poi"
                    name="poi"
                    class="col form-control custom-select"
                    v-model="data.isPrintOnInvoice"
                    :disabled="isSelectVetsource"
                >
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                </select>
            </b-form-group>
            <b-form-group
                v-if="isInvoice"
                class="medical-note"
                :label-for="`soap`"
                :label-cols="4"
                label="Medical Note:"
            >
                <treeselect
                    v-if="data.isMultiplePatient"
                    id="soap"
                    name="soap"
                    placeholder="Medical note (optional)"
                    multiple
                    v-model="data.soaps"
                    :disabled="isSelectVetsource"
                    :options="medicalNotes"
                    :searchable="true"
                    :clearOnSelect="true"
                    valueFormat="object"
                >
                    <label
                        slot="option-label"
                        slot-scope="{ node }"
                        class="font-weight-normal treeselect-opt-margin"
                    >
                        <span>
                            {{ node.label }}
                        </span>
                    </label>
                </treeselect>
                <v-select
                    v-if="!data.isMultiplePatient"
                    id="soap"
                    label="text"
                    name="soap"
                    placeholder="Medical note (optional)"
                    v-model="data.soaps"
                    aria-placeholder="true"
                    :options="medicalNotes"
                    :disabled="isSelectVetsource"
                />
            </b-form-group>
            <b-form-group
                v-if="isInvoice"
                class="create-record"
                label-for="create-record"
                label-cols="4"
                label="Create Records:"
            >
                <b-form-select
                    id="create-record"
                    name="create-record"
                    class="form-control"
                    v-model="data.isHasRecordPage"
                    :disabled="isSelectVetsource"
                >
                    <option :value="CREATERECORD">
                        {{
                            invoiceItem &&
                            invoiceItem.record != null &&
                            !isDuplicate
                                ? "Update"
                                : "Create"
                        }}
                        records
                    </option>
                    <option :value="DONTCREATERECORD">
                        Don't
                        {{
                            invoiceItem &&
                            invoiceItem.record != null &&
                            !isDuplicate
                                ? "update"
                                : "create"
                        }}
                        records
                    </option>
                </b-form-select>
            </b-form-group>

            <b-form-group
                v-if="
                    isInvoice &&
                    isLabItem &&
                    data.isHasRecordPage == CREATERECORD
                "
                label="Lot:"
                label-cols="4"
                label-for="lot"
            >
                <v-select
                    id="lot"
                    v-model="data.lot"
                    :options="lotOptionFilter"
                    :label="'text'"
                    placeholder="Select lot (optional)"
                    name="lot"
                    multiple
                    class="show-actions"
                    :loading="loadingLot"
                >
                    <template #list-header>
                        <div class="menu">
                            <a
                                @click.stop="addLot"
                                class="badge badge-success rounded-0"
                                >Add New</a
                            >
                        </div>
                    </template>
                </v-select>
            </b-form-group>

            <b-form-group
                v-if="(isNew || isDuplicate) && isInvoice"
                label-for="action"
                label-cols="4"
                label="Actions:"
            >
                <v-select
                    id="action"
                    :options="actionFilter"
                    :disabled="isSelectVetsource"
                    v-model="data.action"
                    :label="'text'"
                    placeholder="Actions (optional)"
                    name="action"
                    multiple
                    aria-placeholder="true"
                ></v-select>
            </b-form-group>

            <b-form-group
                v-if="data.isShowPrinter && isInvoice"
                class=""
                :label-for="`printer`"
                :label-cols="4"
                label="Label:"
            >
                <div class="form-inline">
                    <b-form-select
                        id="printer"
                        v-model="data.printer"
                        :options="printerList"
                        :disabled="isSelectVetsource"
                        class="col-8 form-control"
                        name="printer"
                    ></b-form-select>
                    <span class="col-1 p-0 text-center">X</span>
                    <b-form-input
                        id="print_quantity"
                        :disabled="
                            data.printer === 0 ||
                            data.printer === 'no' ||
                            data.printer === 'local' ||
                            isSelectVetsource
                        "
                        v-model="data.print_quantity"
                        name="print_quantity"
                        class="col-3"
                        placeholder="Quantity"
                    ></b-form-input>
                </div>
            </b-form-group>
        </b-form>
        <NewLot ref="newNewLotWindow" @saved="onChangeLot"></NewLot>
    </div>
</template>
<script>
/**
 * @see apps/application/controllers/billing/item.php (function @edit) Line:200
 * @see apps/application/views/staff/billing/invoice/invoice/sub/item/wizard/create_update.php
 * @see apps/application/controllers/billing/return_item.php Line 31 & 157
 * @see apps/application/views/staff/billing/invoice/invoice/sub/item/wizard/invoice_item.php
 * @see apps/application/views/staff/patient/profile/sub/record/record_fields.php
 * @see apps/application/controllers/billing/item.php@1720 : for (add + new)
 * @see apps/assets/js/module/billing/item.js
 *
 * Estimate specific
 * @see apps/application/views/staff/billing/invoice/estimate/sub/item/create_update.php
 */
import {
    union,
    difference,
    find,
    filter,
    sortBy,
    debounce,
    merge,
    forEach,
    isEmpty,
    orderBy,
    differenceBy,
    findIndex,
    cloneDeep,
    uniqBy
} from "lodash";
import vetSelect from "@/module/commons/vet-select.vue";
import vSelect from "vue-select";
import Dosage from "@/module/commons/dosage.vue";
import RecordHelper from "@/mixins/record"; // Most function put here as it share same function with patient> medical record
import InvoiceItemHelper from "@/mixins/invoice-item-multiple-patient"; // The functions that used for calculate the total price
import InvoiceItemService from "@/services/invoice/invoice-item";
import EstimateItemService from "@/services/estimate/estimate-item";
import ItemDiscountService from "@/services/items/items-discount";
import ItemService from "@/services/items";
import ItemActionService from "@/services/items/items-action";
import PatientService from "@/services/patient";
import ClientServices from "@/services/client";
import StaffService from "@/services/staff";
import TemplateService from "@/services/templates";
import ITEMTYPES from "@/constants/item-types";
import INVOICEITEM from "@/constants/invoice-item";
import Treeselect from "@riophae/vue-treeselect";
import NewLot from "@/module/commons/inventory/custom-lot-modal";

const entities = require("entities");
const DEFAULT_WEIGHT = { weight: null, uom: null };
const CREATERECORD = 1;
const DONTCREATERECORD = 0;
const CLIENT_IS_TAXEXEMPT_MSG =
    "This client is tax exempt.  Taxes will be removed when this item is saved.";
const MAX_PATIENT_SELECTED_MSG = "Max 5 patients can be selected.";
const WELLNESSPLAN_PATIENT_MSG_FOR_UNIT_PRICE =
    "Prices, fees and discounts may vary based on eligibility and will be calculated and displayed once the item is saved.";
const WELLNESSPLAN_PATIENTS_MSG =
    "You have selected patient(s) enrolled in a wellness plan. Prices, fees and discounts may vary based on eligibility and will be calculated and displayed once the item is saved.<br><br> You may select to edit the individual line item after it is added to the invoice to view the calculation detail.";
const NOMEDICALNOTE = -1;
const NOMEDICALNOTEOBJECT = {
    value: NOMEDICALNOTE,
    text: "No Medical Note",
    id: NOMEDICALNOTE, // As the Treeselect is using v-show, need to render and the optiosn must has id and label
    label: "No Medical Note"
};
const IS_DISCOUNT_CHANGED = true;
const INITIAL_DATA = () => ({
    // THE DATA USED FOR SAVE
    item: null,
    item_type: null,
    itemName: null,
    discountAmount: parseFloat(0).toFixed(2),
    discountType: 0,
    taxes: [],
    discountId: INVOICEITEM.DISCOUNTS.CUSTOM.id,
    provider: null,
    isPrintOnInvoice: true,
    previousIsPrintOnInvoice: true,
    isHasRecordPage: CREATERECORD,
    quantity: 0,
    unitPrice: 0,
    patientId: null,
    fees: [],
    action: [],
    uomLabel: null,
    uomId: null,
    send_to_device: "",
    source: "",
    send_to: 1,
    originalSourcesLength: null,
    printer: "no",
    print_quantity: 1,
    isShowPrinter: false,

    // THE DATA USED FOR CALCULATION
    fees_price: 0, // DALAM CI ADA
    total_item_price: 0, // ON PRICE PRE-TAX
    minimum_price: null,
    is_plan_item: 0, // for edit invoiceItem with item wellness
    is_non_plan_item: false, // for edit invoiceItem with item wellness
    item_discount: null,
    item_discount_amount: null,
    iitem_unit_price_ori: null, // for edit invoiceItem->unit_price, but dynamically can change
    invoice_discount_id: null,
    invoice_discount_amount: null,
    invoice_discount_item_id: null,
    override_disc_status: 0,
    iitem_fee_price: 0,
    default_iitem_fee_price: 0,
    is_plan_active: 0,
    plan_item_balance: 0,
    iitem_price: 0,
    non_plan_discount: 0,
    is_min_price_tier: 0,
    minimum_price_type: null,
    iitem_orig_item_price: null,
    price_tier_id: null,
    iitem_default_item_price: null,
    remove_invoice_discount: false,
    iitem_default_quantity: 0,
    iitem_default_item_fees: [],
    iitem_item_fees: [], // used to update data.fees upon on changing patient
    iitem_plan_price: null,
    iitemWellnessId: null, // The wellness id from invoice item

    // use by estimate
    defaultMinUnitPrice: 0,
    defaultMaxUnitPrice: 0,
    minUnitPrice: parseFloat(0).toFixed(2),
    maxUnitPrice: parseFloat(0).toFixed(2),
    defaultMinUnitQuantity: 0,
    defaultMaxUnitQuantity: 0,
    minQuantity: 0,
    maxQuantity: null,
    discountMin: null,
    discountMax: null,
    total_item_price_min: parseFloat(0).toFixed(2),
    total_item_price_max: parseFloat(0).toFixed(2),
    isCustomItemFromBundle: null,
    price_tier_min_id: null,
    price_tier_max_id: null,
    isMultiplePatient: false,
    patients: [],
    soaps: [NOMEDICALNOTEOBJECT],
    formattedParamsData: [],
    patientPlanData: [],
    lot: []
});

export default {
    name: "createItemPage",
    components: {
        vSelect,
        vetSelectFee: () => import("@/module/commons/vet-select-fee"),
        vetSelectTax: () => import("@/module/commons/vselect/vet-select-tax"),
        Dosage,
        vetSelect,
        Treeselect,
        NewLot
    },
    mixins: [RecordHelper, InvoiceItemHelper],
    props: {
        hideBackdrop: {
            type: Boolean,
            default: false,
            required: false
        },
        isInvoice: {
            type: Boolean,
            required: true
        },
        invoiceItem: {
            type: Object,
            default: null,
            required: false
        },
        addNew: {
            type: Boolean,
            default: false,
            required: false
        },
        isSaving: {
            type: Boolean,
            default: false,
            required: false
        },
        isDuplicate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            CREATERECORD: CREATERECORD,
            DONTCREATERECORD: DONTCREATERECORD,
            ITEMTYPES: ITEMTYPES,
            INVOICEITEM: INVOICEITEM,
            discountOptions: [INVOICEITEM.DISCOUNTS.CUSTOM],
            WELLNESSPLAN_PATIENTS_MSG: WELLNESSPLAN_PATIENTS_MSG,
            loading: [],
            isDataLoaded: false,
            isButtonTextContinue: false,
            canProceed: true, // based on CI, not all alert message disallow to proceed
            alertMessages: [], // handle multiple alert messages
            alertMessage: null, // for alert message from calculations invoice-item.js, to prevent regressions hence not apply the multple alertmessages
            vetItemProps: {
                id: "",
                item_type: "",
                module: "billing",
                status: 1,
                start: "",
                source: ""
            },
            weight: DEFAULT_WEIGHT,
            isSkipWatch: false,
            data: INITIAL_DATA(),
            datePickerOptions: {
                format: "DD/MM/YYYY",
                widgetParent: "#createItemPage"
            },
            actions: [],
            medicalNotes: [NOMEDICALNOTEOBJECT],
            providers: [],
            formError: [],
            isDisabledSendTo: false,
            originalSourcesLength: null,
            sendToLabLabel: "Send to Lab:",
            sourceResources: null,
            sendToDeviceOptions: [],
            showSendToLab: false,
            med_record_rad: false,
            printerList: [],
            patientOptions: [],
            defaultPrinter: null,
            tempDisableButton: false,
            patientMedicalNotes: [],
            hideUnitPrice: "",

            // extra checking to skip watch max quantity
            isPriceTier: false,
            changePrice: false,
            itemLotOption: [],
            loadingLot: false
        };
    },
    computed: {
        patientsId() {
            return this.data.patients.map(patient => patient.id);
        },
        soapsId() {
            return this.data.soaps.map(soap => soap.id);
        },
        formattedParams() {
            return this.patientsId.map((patientId, index) => ({
                patientId: patientId,
                soap_id: this.soapIdsForPatient(patientId)
            }));
        },
        patientName() {
            return this.data.patients &&
                this.data.patients.length > 0 &&
                this.data.patients[0].name
                ? this.data.patients[0].name
                : "";
        },
        patientOptionsFilter() {
            return differenceBy(this.patientOptions, this.data.patients, "id");
        },
        actionFilter() {
            return difference(this.actions, this.data.action);
        },
        isNew() {
            return this.invoiceItem == null;
        },
        invoice() {
            return this.$store.getters["billing/invoiceDetails"];
        },
        isItemAllowMultiplePatient() {
            return (
                (isEmpty(this.data.item) ||
                    ![
                        ITEMTYPES.TYPES.TYPE_RADIOLOGY,
                        ITEMTYPES.TYPES.TYPE_LAB
                    ].includes(this.data.item_type)) &&
                this.isNew &&
                this.isInvoice
            );
        },
        isMultiplePatient() {
            return (
                this.isItemAllowMultiplePatient &&
                this.data.patients &&
                this.data.patients.length > 1
            );
        },
        estimate() {
            return this.$store.getters["billing/estimateDetails"];
        },
        feesId() {
            return filter(
                this.data.fees.map(f => f.id),
                data => data != null
            );
        },
        isDiscountCustom() {
            return this.data.discountId == INVOICEITEM.DISCOUNTS.CUSTOM.id;
        },
        isLoading() {
            return !(this.loading.length == 0);
        },
        isDisabled() {
            return this.isLoading || this.isSaving;
        },
        clientId() {
            return this.isInvoice
                ? this.invoice.client_id
                : this.estimate.client_id;
        },
        isExcludedFromTaxes() {
            return this.isInvoice
                ? this.invoice.client.isExcludedFromTaxes
                : this.estimate.client
                ? this.estimate.client.isExcludedFromTaxes
                : false;
        },
        patientPlaceholder() {
            return this.isInvoice ? "Patient (required)" : "Patient (optional)";
        },
        providerPlaceholder() {
            return this.isInvoice
                ? "Provider (required)"
                : "Provider (optional)";
        },
        showPatientField() {
            return this.isInvoice || (!this.isInvoice && this.estimate.client);
        },
        isSelectVetsource() {
            return this.data.item && this.data.item.source === "VETSOURCE";
        },
        showDiscountRange() {
            return !this.isInvoice && !this.isNew && this.isDiscountCustom;
        },
        validationMaxUniPriceRules() {
            let rules = `decimal:2`;
            if (this.data.maxQuantity) {
                rules += "|required";
            }

            if (!this.isPriceTier && !this.isInvoice && this.changePrice) {
                rules += `|min_value:${this.data.minUnitPrice}`;
            }
            return rules;
        },
        hasNoEnroll() {
            return this.data?.patientPlanData?.patients?.some(
                patient =>
                    patient?.is_plan === false && patient?.is_non_plan === false
            );
        },
        hasEnrollPlan() {
            return this.data?.patientPlanData?.patients?.some(
                patient => patient?.is_plan === true
            );
        },
        hasEnrollNonPlan() {
            return this.data?.patientPlanData?.patients?.some(
                patient => patient?.is_non_plan === true
            );
        },
        hasPatientWellnessPlan() {
            return (
                this.data.isMultiplePatient &&
                (this.hasEnrollPlan || this.hasEnrollNonPlan)
            );
        },
        isLabItem() {
            return [ITEMTYPES.TYPES.TYPE_LAB].includes(this.data.item_type);
        },
        isQuantityDisabled() {
            if (!this.invoiceItem) return false;

            return (
                this.invoiceItem?.record_resource?.quantity_editable == false ||
                this.invoiceItem?.quantity_editable == false
            );
        }
    },
    watch: {
        isMultiplePatient(value) {
            //  To pass to create-record
            this.data.isMultiplePatient = value;
        },
        /* eslint-disable  no-unused-vars */
        "data.source"(value, oldValue) {
            this.updateFieldsBasedOnSource("invoice-item", value, oldValue);
        },
        canProceed(value) {
            this.$emit("can-proceed", value);
        },
        loading(value) {
            this.$emit("loading", this.isLoading);
        },
        isButtonTextContinue(value) {
            this.$emit("is-button-text-continue", value);
        },
        async "data.patients"(value, oldValue) {
            if (this.isSkipWatch) {
                return;
            }
            this.isSkipWatch = true;
            await this.patientsChanged(value, oldValue);
            this.isSkipWatch = false;
        },
        "data.soaps"(value, oldValue) {
            this.soapsChanged(value, oldValue);
        },
        "data.isPrintOnInvoice"(value, oldValue) {
            this.data.previousIsPrintOnInvoice = oldValue;
            if (this.isSkipWatch) {
                return;
            }
            this.onChangeIsPrintOnInvoice();
        },
        "data.discountId"(value, oldValue) {
            if (this.isSkipWatch) {
                return;
            }
            this.onChangeDiscount(true);
        },
        "data.discountAmount"(value) {
            if (this.isSkipWatch) {
                return;
            }
            this.onChangeDiscount(false, IS_DISCOUNT_CHANGED);
        },
        "data.discountType"(value) {
            if (this.isSkipWatch) {
                return;
            }
            this.onChangeDiscount(false, IS_DISCOUNT_CHANGED);
        },
        "data.item"(value, oldValue) {
            if (this.isSkipWatch) {
                return;
            }
            this.onChangeItem(value, oldValue);
        },
        "data.quantity"(value) {
            if (this.isSkipWatch) {
                return;
            }

            if (this.isInvoice && !this.isNew) {
                this.$emit(
                    "update-lot",
                    Number(value) != Number(this.invoiceItem.quantity)
                );
            }
            this.onChangeQuantity();
        },
        "data.minQuantity"(value) {
            if (this.isSkipWatch) {
                return;
            }
            this.onChangeQuantity("min");
        },
        "data.maxQuantity"(value) {
            if (this.isSkipWatch) {
                return;
            }
            this.onChangeQuantity("max");
        },
        "data.fees"(value, oldValue) {
            if (this.isSkipWatch) {
                return;
            }

            // if removed, reset iitem_item_fees to empty
            if (value.length < oldValue.length) {
                this.data.iitem_item_fees = [];
            }

            this.onChangeFees();
        },
        "data.unitPrice"(value) {
            if (this.isSkipWatch) {
                return;
            }
            this.onChangeUnitPrice();
        },
        async "data.minUnitPrice"(value) {
            if (this.isSkipWatch) {
                return;
            }
            this.changePrice = true;
            await this.onChangeUnitPrice("min");
            this.validateUnitPrice();
        },
        async "data.maxUnitPrice"(value) {
            if (this.isSkipWatch) {
                return;
            }
            this.changePrice = true;

            await this.onChangeUnitPrice("max");
            this.validateUnitPrice();
        },
        "data.isHasRecordPage"(value) {
            // later can make this as a computed
            this.data.isShowPrinter =
                value == CREATERECORD &&
                (this.data.item_type != undefined ||
                    this.data.item_type != null) &&
                [
                    ITEMTYPES.TYPES.TYPE_OTHER_FEES,
                    ITEMTYPES.TYPES.TYPE_LAB
                ].includes(this.data.item_type);

            this.$emit("is-has-record-page", value);
        },
        "data.provider"(value, oldValue) {
            const isLabUseClinicProvider =
                (this.data.item_type == ITEMTYPES.TYPES.TYPE_LAB ||
                    this.data.item_type == ITEMTYPES.TYPES.TYPE_RADIOLOGY) &&
                value &&
                value.is_default_provider;

            if (
                !isLabUseClinicProvider &&
                oldValue &&
                oldValue.is_default_provider
            ) {
                if (
                    this.alertMessages.includes(
                        RecordHelper.LAB_USE_CLINIC_PROVIDER_MSG
                    )
                ) {
                    this.removeAlertMessages(
                        RecordHelper.LAB_USE_CLINIC_PROVIDER_MSG
                    );
                }
                this.removeFormError("provider");
            }
        },
        tempDisableButton(value) {
            this.$emit("temporary-disable-button", value);
        },
        formattedParams(newValue) {
            if (newValue) {
                this.formattedParamsData = newValue;
            }
        }
    },
    created() {
        this.formattedParamsData = this.formattedParams;
    },
    mounted() {},
    methods: {
        soapIdsForPatient(patientId) {
            if (this.data.soaps?.[0]) {
                return this.data.soaps
                    .filter(soap => soap.patientId === patientId)
                    .map(soap => soap.id);
            }
            return [];
        },
        async patientsChanged(value) {
            let self = this;

            this.data.plan_item_balance = 0;
            this.data.patientPlanData = [];
            const resetDiscount = () => {
                // Only for empty or single patient
                if (
                    this.data.discountId ===
                        INVOICEITEM.DISCOUNTS.WELLNESS.id ||
                    this.hasEnrollPlan
                ) {
                    this.data.discountAmount = parseFloat(0).toFixed(2);
                    this.data.discountType = 0;
                    this.data.discountId = INVOICEITEM.DISCOUNTS.CUSTOM.id;

                    this.discountOptions = filter(
                        this.discountOptions,
                        discount => {
                            return (
                                discount.id != INVOICEITEM.DISCOUNTS.WELLNESS.id
                            );
                        }
                    );
                }
            };

            if (value && value.length > 0) {
                this.loading.push("onChangePatient");

                // Handle single patient selection
                if (value.length == 1) {
                    // As for component vue-select that handle single selection of patient, we use patients[0] in the v-model, so it can be the value selected is null when removed the patient.
                    if (value[0] == null) {
                        self.data.patients = [];
                        this.removeLoadingItem("onChangePatient");
                        return;
                    }

                    if (this.data.soaps && this.data.soaps.length > 0) {
                        const selectedSoapsBelongsToPatient = find(
                            this.data.soaps,
                            {
                                patientId:
                                    value.length > 1
                                        ? value[value.length - 1].id
                                        : value[0].id
                            }
                        );
                        if (selectedSoapsBelongsToPatient) {
                            this.data.soaps = [selectedSoapsBelongsToPatient];
                        } else {
                            this.data.soaps = [NOMEDICALNOTEOBJECT];
                        }
                    }
                }

                this.data.patientId =
                    value.length > 1 ? value[value.length - 1].id : value[0].id;

                // List of medical note and latest weight vital for each patients
                let promises = [];
                for (const patient of value) {
                    promises.push(
                        self.getAndSetMedicalNote(patient.id, patient.name)
                    );
                    promises.push(self.getLatestVital(patient.id));
                    await Promise.all(promises).then();
                }

                if (value.length > 1) {
                    // Remove the selected soaps of removed patient
                    const selectedPatientId = this.data.patients.map(
                        patient => patient.id
                    );
                    this.data.soaps = this.data.soaps.filter(soap => {
                        return selectedPatientId.includes(soap.patientId);
                    });
                    self.updateIsDisabledMedicalNote(this.data.soaps);
                }

                if (value.length === 5) {
                    this.pushAlertMessages(MAX_PATIENT_SELECTED_MSG);
                } else {
                    this.removeAlertMessages(MAX_PATIENT_SELECTED_MSG);
                }

                await this.set_plan_price();

                if (value.length == 1) {
                    // Reset the discount after API set plan price to get latest update on hasEnrollPlan param
                    resetDiscount();
                }

                if (this.isInvoice) {
                    // VET-10914 : IN CI and before multiple patient, both params (isCalculateItemPrice and storeDiscount) always false
                    let isCalculateItemPrice = false;
                    let storeDiscount = false;
                    if (this.data.isMultiplePatient) {
                        isCalculateItemPrice = true;
                        storeDiscount = true;
                        if (this.hasEnrollPlan || this.hasEnrollNonPlan) {
                            if (
                                (this.hasEnrollPlan && this.hasEnrollNonPlan) ||
                                !this.hasNoEnroll
                            ) {
                                this.data.discountId =
                                    INVOICEITEM.DISCOUNTS.CUSTOM.id;
                            }
                        }
                    }

                    await this.calculateDiscountAndTotalPrice(
                        isCalculateItemPrice,
                        storeDiscount
                    );
                    this.checkToShowWellnessMessage();
                }

                this.removeLoadingItem("onChangePatient");
            } else {
                self.medicalNotes = [NOMEDICALNOTEOBJECT];
                self.data.soaps = [NOMEDICALNOTEOBJECT];
                this.removeAlertMessages(MAX_PATIENT_SELECTED_MSG);
                resetDiscount();
                this.recalculate_invoice_total();
            }
        },
        selectablePatient(opt) {
            // To disable the other patients to be selected when the patients selected is 5
            return (
                (this.data.patients && this.data.patients.length < 5) ||
                this.data.patients.some(
                    selectedPatient => selectedPatient.id === opt.id
                )
            );
        },
        updateIsDisabledMedicalNote(value) {
            // Only 1 medical note can be selected for each patient when the patients selected is more than 1
            // To disable the selection of other medical note on the same patient when 1 of the medical note of the patient been selected
            if (!Array.isArray(value)) {
                value = [value];
            }
            const selectedSoapValue = value.map(soap => soap.value);
            let selectedSoapPatientId = value.map(soap => soap.patientId);
            this.medicalNotes.forEach(medicalNote => {
                if (
                    selectedSoapPatientId.includes(medicalNote.patientId) &&
                    !selectedSoapValue.includes(medicalNote.value)
                ) {
                    medicalNote.isDisabled = true;
                } else {
                    medicalNote.isDisabled = false;
                }
            });
        },
        soapsChanged(value, oldValue) {
            if (value === null || value[0] === null) {
                return;
            }

            this.updateIsDisabledMedicalNote(value);
            if (
                !this.isMultiplePatient &&
                value.length > 0 &&
                value[0].value != NOMEDICALNOTEOBJECT.value
            ) {
                this.data.isHasRecordPage = CREATERECORD;
            }
        },
        async getPatients() {
            let response = await ClientServices.getPatientsByClient(
                this.isInvoice
                    ? this.invoice.client_id
                    : this.estimate.client_id,
                !this.invoiceItem || this.isDuplicate ? [1, 3] : [1, 2, 3], // 1:active, 2: inactive(edit record), 3:deceased (ci show the deceased patient)
                false
            );

            this.patientOptions = filter(response, res => {
                return res.isactive;
            });
        },
        removeLoadingItem(item) {
            // when rendering, will add in this loading
            // when done rendered, remove from the loading array
            const index = this.loading.indexOf(item);
            if (index > -1) {
                this.loading.splice(index, 1);
            }
        },
        debounceUnitPrice(value) {
            this.tempDisableButton = true;
            this.debounceInput(value, this, "unitPrice");
        },
        debounceMinUnitPrice(value) {
            this.isPriceTier = false;
            this.tempDisableButton = true;
            this.debounceInput(value, this, "minUnitPrice");
        },
        debounceMaxUnitPrice(value) {
            this.isPriceTier = false;
            this.tempDisableButton = true;
            this.debounceInput(value, this, "maxUnitPrice");
        },
        debounceQuantity(value) {
            this.tempDisableButton = true;
            this.debounceInput(value, this, "quantity");
        },
        debounceMinQuantity(value) {
            this.tempDisableButton = true;
            this.debounceInput(value, this, "minQuantity");
        },
        debounceMaxQuantity(value) {
            this.tempDisableButton = true;
            this.debounceInput(value, this, "maxQuantity");
        },
        debounceDiscountAmount(value) {
            this.tempDisableButton = true;
            this.debounceInput(value, this, "discountAmount");
        },
        debounceInput: debounce((value, vm, model) => {
            switch (model) {
                case "unitPrice":
                    vm.data.unitPrice = value;
                    break;
                case "minUnitPrice":
                    vm.data.minUnitPrice = value;
                    break;
                case "maxUnitPrice":
                    vm.data.maxUnitPrice = value;
                    break;
                case "quantity":
                    vm.data.quantity = value;
                    break;
                case "minQuantity":
                    vm.data.minQuantity = value;
                    break;
                case "maxQuantity":
                    vm.data.maxQuantity = value;
                    break;
                case "discountAmount":
                    vm.data.discountAmount = value;
                    break;
                default:
                    break;
            }
            vm.tempDisableButton = false;
        }, 1500),
        immediateUnitPrice(value) {
            this.data.unitPrice = value;
        },
        immediateMinUnitPrice(value) {
            this.data.minUnitPrice = value;
        },
        immediateMaxUnitPrice(value) {
            this.data.maxUnitPrice = value;
        },
        immediateQuantity(value) {
            this.data.quantity = value;
        },
        immediateMinQuantity(value) {
            this.data.minQuantity = value;
        },
        immediateMaxQuantity(value) {
            this.data.maxQuantity = value;
        },
        immediateDiscountAmount(value) {
            this.data.discountAmount = value;
        },
        // ONCHANGE INPUTS disocunt, quantity, unit Price, fees, item and print_on_invoice
        async onChangeDiscount(
            isSwitchDiscount = false,
            isDiscountChanged = !IS_DISCOUNT_CHANGED
        ) {
            this.isSkipWatch = true;
            this.loading.push("onChangeDiscount");
            if (isSwitchDiscount) {
                await this.switch_discount();
            }

            if (this.isInvoice) {
                await this.recalculate_invoice_total();
            } else {
                await this.recalculate_estimate_total();
            }

            if (isDiscountChanged) {
                await this.check_negative_invoice_total();
            }

            this.isSkipWatch = false;
            this.removeLoadingItem("onChangeDiscount");
        },
        async onChangeQuantity(level = null) {
            this.isSkipWatch = true;
            this.loading.push("onChangeQuantity");
            this.isInvoice
                ? await this.calculateDiscountAndTotalPrice()
                : await this.calculateDiscountAndTotalPriceEstimate(
                      true,
                      true,
                      level
                  );
            this.isSkipWatch = false;
            if (
                !this.isNew &&
                this.invoiceItem?.record_resource &&
                this.isLabItem &&
                !this.isDuplicate
            ) {
                this.applyLot(this.invoiceItem.record_resource, true);
            }

            // new or duplicate = false , else edit = true
            if (this.isLabItem && this.data?.item?.id) {
                this.$parent.$children[0].getInventoryLot(
                    this.data.item.id,
                    this.isNew || this.isDuplicate ? false : true
                );
            }

            this.removeLoadingItem("onChangeQuantity");
        },
        async onChangeUnitPrice(level = null) {
            this.isSkipWatch = true;
            this.loading.push("onChangeUnitPrice");
            this.data.isPrintOnInvoice = true;
            this.isInvoice
                ? await this.calculateDiscountAndTotalPrice(true, true, true)
                : await this.calculateDiscountAndTotalPriceEstimate(
                      false,
                      true,
                      level
                  );
            this.isSkipWatch = false;
            this.removeLoadingItem("onChangeUnitPrice");
        },
        async onChangeFees() {
            this.isSkipWatch = true;
            this.loading.push("onChangeFees");
            this.data.isPrintOnInvoice = true;
            await this.calculate_discount(true);
            await this.calculate_fee();
            this.isInvoice
                ? await this.recalculate_invoice_total()
                : await this.recalculate_estimate_total();
            await this.check_negative_invoice_total();
            this.isInvoice
                ? await this.recalculate_invoice_total()
                : await this.recalculate_estimate_total();

            this.isSkipWatch = false;
            this.removeLoadingItem("onChangeFees");
        },
        async onChangeItem(value, oldValue) {
            let self = this;
            this.isSkipWatch = true;
            this.loading.push("onChangeItem");

            // initial value
            this.data.is_min_price_tier = 1;
            this.data.fees = [];
            this.data.taxes = [];
            this.discountOptions = [INVOICEITEM.DISCOUNTS.CUSTOM];
            this.data.discountAmount = parseFloat(0).toFixed(2);
            this.data.discountType = 0;
            this.data.discountId = INVOICEITEM.DISCOUNTS.CUSTOM.id;
            this.sourceOptions = [];
            this.showSendToLab = false;
            this.data.source = null;
            this.data.send_to_device = 0;
            this.data.plan_item_balance = 0;
            this.data.is_plan_active = 0;
            this.data.is_plan_item = false;
            this.data.is_min_price_tier = 0;
            this.data.patientPlanData = [];
            $(".lab-record").hide();

            // To handle multiple patient
            if (
                value &&
                [
                    ITEMTYPES.TYPES.TYPE_RADIOLOGY,
                    ITEMTYPES.TYPES.TYPE_LAB
                ].includes(parseInt(value.item_type))
            ) {
                // Item not empty and it is lab and if patient has more than 1, reset the patient and soap
                if (this.data.patients && this.data.patients.length > 1) {
                    this.data.patients = [];
                    this.data.soaps = [];
                }
            } else if (
                oldValue &&
                [
                    ITEMTYPES.TYPES.TYPE_RADIOLOGY,
                    ITEMTYPES.TYPES.TYPE_LAB
                ].includes(parseInt(oldValue.item_type)) &&
                ((value &&
                    ![
                        ITEMTYPES.TYPES.TYPE_RADIOLOGY,
                        ITEMTYPES.TYPES.TYPE_LAB
                    ].includes(parseInt(value.item_type))) ||
                    !value)
            ) {
                // Old item is lab/imaging then change to empty/other item
                // The patients and soaps will be maintained
                // The comment is for debugging during development
            }

            if (this.data.item && (this.isNew || !this.isInvoice)) {
                const ITEM_TYPE = parseInt(this.data.item.item_type);

                if (this.data.item.isNewCreated) {
                    const item = await this.getItemNewCreated(
                        this.data.item.id
                    ); // to have the same object as filter_items
                    this.data.item = Object.assign(item, this.data.item);
                }

                const itemDetails = await this.getItemDetails(
                    this.data.item.id
                );

                this.data.item = Object.assign(this.data.item, itemDetails);
                this.data.item.fees = itemDetails.fees.map(f => {
                    if (f.cost_plus_price) {
                        f.label += ` (${f.cost_plus_price.account_format})`;
                    }
                    f.name = f.label;
                    return f;
                });

                this.data.item.code = itemDetails.masterItem.code;
                this.data.item.taxes = itemDetails.taxes;

                if (ITEM_TYPE == ITEMTYPES.TYPES.TYPE_LAB) {
                    $(".lab-record").show();
                    if (itemDetails) {
                        self.data.source = self.data.source
                            ? self.data.source
                            : itemDetails.masterItem.source;

                        if (
                            self.data.source ||
                            self.data.source === itemDetails.masterItem.source
                        ) {
                            self.updateFieldsBasedOnSource(
                                "invoice-item",
                                self.data.source
                            );
                        }
                    }
                    self.initLabFields(this.data.item);
                }

                this.getDiscountsByItem(this.data.item.id);
                this.getTaxFeeByItem(this.data.item.id);

                this.data.isPrintOnInvoice =
                    this.data.item.is_print_on_invoice == 1;
                this.data.quantity = this.data.item.dose;
                this.data.iitem_default_quantity = this.data.item.dose;
                this.data.unitPrice = this._toNumber(
                    this.data.item.unit_price,
                    2,
                    false
                );

                this.data.is_min_price_tier = 1; // always set to 1 when item is selected
                this.data.iitem_unit_price_ori = this.data.item.unit_price_ori;
                this.data.iitem_orig_item_price = this.data.item.unit_price_ori;
                this.data.iitem_default_item_price =
                    this.data.item.price / this.data.item.dose;
                this.data.minimum_price = this.data.item.minimum_price;
                this.data.minimum_price_type = this.data.item.minimum_price_type;

                // use by estimate
                if (!this.isInvoice) {
                    this.data.minQuantity = this.data.item.dose;
                    this.data.iitem_default_min_quantity = this.data.item.dose;
                    this.data.minUnitPrice = parseFloat(
                        this.data.item.unit_price
                    ).toFixed(2);
                    this.data.maxUnitPrice = parseFloat(
                        this.data.item.unit_price
                    ).toFixed(2);
                    this.data.defaultMinUnitPrice = this.data.item.unit_price;
                    this.data.defaultMaxUnitPrice = this.data.item.unit_price;
                    this.data.iitem_min_unit_price_ori = this.data.item.unit_price_ori;
                    this.data.iitem_max_unit_price_ori = 0;
                    this.data.iitem_orig_item_min_price = this.data.item.unit_price_ori;
                    this.data.iitem_orig_item_max_price = this.data.item.unit_price_ori;
                    this.data.iitem_default_item_fees = this.data.item.fees;
                    if (
                        this.alertMessages.includes(
                            INVOICEITEM.ALERT_MESSAGE
                                .LOW_UNIT_PRICE_VALUE_LOWER_THAN_HIGH
                        )
                    ) {
                        this.removeAlertMessages(
                            INVOICEITEM.ALERT_MESSAGE
                                .LOW_UNIT_PRICE_VALUE_LOWER_THAN_HIGH
                        );
                    }
                }

                this.data.iitem_item_fees = this.data.item.fees;
                if (this.data.isPrintOnInvoice == 1) {
                    this.data.fees = this.data.item.fees;
                }

                if (this.data.item.uom) {
                    this.data.uomLabel = this.data.item.uom.label;
                    this.data.uomId = this.data.item.uom.id;
                }

                this.data.iitem_fee_price = this.data.item.fees_price; // take from API filter_items
                this.data.default_iitem_fee_price = this.data.item.fees_price;

                this.data.item_type = ITEM_TYPE;

                // For lab/fee will not create the record in this dialog
                this.$emit(
                    "is-type-has-record-page",
                    ![
                        ITEMTYPES.TYPES.TYPE_OTHER_FEES,
                        ITEMTYPES.TYPES.TYPE_LAB
                    ].includes(ITEM_TYPE)
                );

                this.data.isHasRecordPage = CREATERECORD;

                // when item type fee or lab will not have record page hence printer field will shown here
                this.data.isShowPrinter =
                    [
                        ITEMTYPES.TYPES.TYPE_OTHER_FEES,
                        ITEMTYPES.TYPES.TYPE_LAB
                    ].includes(ITEM_TYPE) &&
                    this.data.isHasRecordPage == CREATERECORD;

                self.checkImageTypeFields(this.data.item);

                self.data.source = self.data.item.source; // took from API filter_items
                self.updateFieldsBasedOnSource(
                    "invoice-item",
                    self.data.source
                );

                this.data.itemName = this.data.item.display_name;

                this.data.action = [];
                if (this.data.item.actions) {
                    this.addActions(this.data.item.actions);
                }
                this.data.minimum_price = this.data.item.minimum_price;

                await this.set_plan_price();

                if (this.isInvoice) {
                    await this.calculateDiscountAndTotalPrice(false, false);
                } else {
                    await this.calculateDiscountAndTotalPriceEstimate(
                        true,
                        false,
                        "min"
                    );
                    await this.calculateDiscountAndTotalPriceEstimate(
                        true,
                        false,
                        "max"
                    );
                }

                if (this.data.isShowPrinter) {
                    this.setPrinterLabel(this.data.item.print_label);
                }
                // reset price for estimate
            }

            this.checkToShowWellnessMessage();
            if (this.isSelectVetsource) {
                this.data.isHasRecordPage = DONTCREATERECORD;
            }
            this.isSkipWatch = false;
            if (this.isInvoice && this.isLabItem && self.data?.item?.id) {
                await self.getInventoryLot(self.data.item.id, false);
            }

            this.removeLoadingItem("onChangeItem");
        },
        async checkImageTypeFields() {
            const ASTERIS = "ASTERIS";
            const IDEXX_DR = "IDEXX_DR";
            const SOUNDPACS = "SOUNDPACS";

            let self = this;
            let item = this.data.item;

            self.med_record_rad = false;
            self.sendToDeviceOptions = [];
            if (this.isNew && item) {
                // Use the data from API barramundi first
                const ITEM_TYPE = this.data.item.itemType
                    ? this.data.item.itemType.id
                    : parseInt(this.data.item.item_type);

                if (
                    item.id &&
                    item.source &&
                    ITEM_TYPE == ITEMTYPES.TYPES.TYPE_RADIOLOGY &&
                    (item.source.toUpperCase() == ASTERIS ||
                        item.source.toUpperCase() == IDEXX_DR ||
                        item.source.toUpperCase() == SOUNDPACS)
                ) {
                    if (
                        typeof item.sources != "undefined" &&
                        item.sources != null &&
                        item.sources != "null"
                    ) {
                        if (Object.keys(item.sources).length > 1) {
                            forEach(item.sources, function (value, key) {
                                self.sendToDeviceOptions.push({
                                    value: key,
                                    text: value
                                });
                            });

                            self.data.send_to_device =
                                self.sendToDeviceOptions[1].value;
                        }
                        self.med_record_rad = true;
                    }
                }
            } else if (!this.isNew && this.invoiceItem.record_resource) {
                // edit
                const formData = this.invoiceItem.record_resource.form_data;

                let recordResource = formData.record_resource
                    ? formData.record_resource
                    : null;
                let sendTo =
                    recordResource && recordResource.SendTo
                        ? recordResource.SendTo
                        : null;
                let imageSources = formData.imaging_sources
                    ? formData.imaging_sources
                    : null;

                if (recordResource && imageSources) {
                    // Hide Send To Lab
                    self.showSendToLab = false;

                    if (
                        isEmpty(recordResource.Source) &&
                        sendTo != 1 &&
                        sendTo != "1"
                    ) {
                        if (Object.keys(imageSources).length != 0) {
                            forEach(imageSources, function (value, key) {
                                self.sendToDeviceOptions.push({
                                    value: key,
                                    text: value
                                });
                            });

                            self.data.send_to_device =
                                self.sendToDeviceOptions[0].value;
                            self.med_record_rad = true;
                        }
                    } else if (
                        recordResource.Source &&
                        (recordResource.Source.toUpperCase() == ASTERIS ||
                            recordResource.Source.toUpperCase() == IDEXX_DR ||
                            recordResource.Source.toUpperCase() == SOUNDPACS) &&
                        (sendTo == 1 || sendTo == "1")
                    ) {
                        forEach(imageSources, function (value, key) {
                            self.data.send_to_device = key;
                        });
                    }
                }
            }
        },
        async onChangeIsPrintOnInvoice() {
            this.isSkipWatch = true;
            this.loading.push("onChangeIsPrintOnInvoice");

            if (!this.data.isPrintOnInvoice) {
                this.data.iitem_item_price = this.data.iitem_price;
                this.data.unitPrice = this._toNumber(0, 2, false);
                this.data.iitem_unit_price_ori = this._toNumber(0, 2, false);

                if (!this.isInvoice) {
                    this.data.total_item_price_min = parseFloat(0).toFixed(2);
                    this.data.total_item_price_max = parseFloat(0).toFixed(2);
                    this.data.minUnitPrice = parseFloat(0).toFixed(2);
                    this.data.maxUnitPrice = parseFloat(0).toFixed(2);
                    this.data.discountMin = this.data.discountMin
                        ? parseFloat(0).toFixed(2)
                        : null;
                    this.data.discountMax = this.data.discountMax
                        ? parseFloat(0).toFixed(2)
                        : null;
                    this.data.discountAmount = parseFloat(0).toFixed(2);
                } else {
                    // invoice
                    if (this.data.is_plan_item) {
                        this.data.total_item_price =
                            "0.00 (0.00 included in plan)";
                    } else {
                        this.data.total_item_price = "0.00";
                    }
                    this.data.discountAmount = 0;
                }
                this.data.iitem_price = 0;
                this.data.discountType = 0;
                this.data.iitem_fee_price = 0;
                this.data.fees = [];

                await this.verify_override_disc_status();
                this.isInvoice
                    ? await this.recalculate_invoice_total()
                    : await this.recalculate_estimate_total();
                await this.check_negative_invoice_total();
            } else {
                //reset is_min_price_tier to 1 when change poi to yes
                this.data.is_min_price_tier = 1;
                if (!this.isInvoice) {
                    // for estimate
                    //reset unit price min and unit price max default to inventory
                    this.data.defaultMinUnitPrice = this.data.iitem_orig_item_price;
                    this.data.defaultMaxUnitPrice = this.data.iitem_orig_item_price;
                    this.data.fees = this.data.iitem_default_item_fees;

                    await this.calculate_fee();
                    await this.calculateDiscountAndTotalPriceEstimate(
                        true,
                        true,
                        "min"
                    );
                    await this.calculateDiscountAndTotalPriceEstimate(
                        true,
                        true,
                        "max"
                    );
                } else {
                    this.data.quantity = this.data.iitem_default_quantity;
                    this.data.fees = this.data.iitem_default_item_fees;

                    await this.calculate_fee();
                    await this.calculateDiscountAndTotalPrice();
                }
            }
            this.isSkipWatch = false;
            this.removeLoadingItem("onChangeIsPrintOnInvoice");
        },
        async getAndSetMedicalNote(patientId, patientName = null) {
            let self = this;

            if (!(patientId in self.patientMedicalNotes)) {
                const medicalNotes = await this.getMedicalNote(
                    patientId,
                    !RecordHelper.SET_MEDICAL_NOTES_OPTIONS
                );

                medicalNotes.forEach(medicalNote => {
                    medicalNote.patientId = patientId;
                    medicalNote.patientName = patientName;
                    medicalNote.isDisabled = false; // Used for treeselect
                    medicalNote.id = medicalNote.value; // Used for treeselect
                    medicalNote.label = `${patientName} - ${medicalNote.text}`; // Used for treeselect
                });
                self.patientMedicalNotes[patientId] = medicalNotes;
            }

            // Update the this.medicalNotes
            if (this.data.isMultiplePatient) {
                let mergedMedicalNotes = [];
                this.data.patients.map(patient => {
                    if (self.patientMedicalNotes[patient.id]) {
                        mergedMedicalNotes = mergedMedicalNotes.concat(
                            cloneDeep(self.patientMedicalNotes[patient.id])
                        );
                    }
                });
                // Remove duplicates based on the 'value' property
                self.medicalNotes = orderBy(
                    uniqBy(mergedMedicalNotes, "value"),
                    ["date", "patientName"],
                    ["desc", "asc"]
                );
            } else if (
                this.data.patients.length > 0 &&
                this.data.patients[0].id === patientId
            ) {
                self.medicalNotes = cloneDeep(
                    self.patientMedicalNotes[patientId]
                );
                self.medicalNotes.unshift(NOMEDICALNOTEOBJECT);
            } else {
                self.medicalNotes = [NOMEDICALNOTEOBJECT];
            }

            if (
                this.invoiceItem &&
                this.invoiceItem.record &&
                this.invoiceItem.record.soap_id
            ) {
                // For edit invoice item
                const mn = find(this.medicalNotes, {
                    value: this.invoiceItem.record.soap_id
                });

                if (mn) {
                    self.data.soaps = [mn];
                }
            }
        },
        async getInvoiceEstimateItemDetails(ItemId) {
            return this.isInvoice
                ? await InvoiceItemService.getInvoiceItem(ItemId)
                : await EstimateItemService.getEstimateItem(ItemId);
        },
        async getItemNewCreated(itemId) {
            return await ItemService.getItems({
                id: this.isInvoice ? this.invoice.id : this.estimate.id,
                module: "billing",
                status: Number(this.isInvoice),
                start: this._now().toFormat(this._getLuxonFormat()),
                item_id: itemId
            });
        },
        getTaxFeeByItem() {
            if (this.data.item) {
                this.loading.push("getTaxFeeByItem");
                InvoiceItemService.getTaxFeeByItem(this.data.item.id, {
                    status: Number(this.isInvoice), // 1=Invoice, 0=Estimate
                    invoice_id: this.isInvoice
                        ? this.invoice.id
                        : this.estimate.id, // Invoice/Estimate id
                    item_type_category_id: this.data.item.item_type_category
                        ? this.data.item.item_type_category.id
                        : this.data.item.item_type_category_id
                }).then(res => {
                    if (
                        this.$refs.vetSelectTaxes &&
                        this.data.isPrintOnInvoice &&
                        res.taxes != ""
                    ) {
                        const taxesArr = res.taxes.split(",").map(Number);
                        this.data.taxes = filter(this.data.item.taxes, tax => {
                            tax.name = tax.label;
                            return taxesArr.includes(tax.id);
                        });
                    }

                    this.data.fees_price = res.fees_price;
                    this.removeLoadingItem("getTaxFeeByItem");
                });
            }
        },
        construct() {
            let self = this;
            self.isSkipWatch = true;
            self.loading.push("construct");
            self.alertMessages = [];
            self.alertMessage = null;
            self.vetItemProps = {
                id: this.isInvoice ? this.invoice.id : this.estimate.id,
                item_type: "",
                module: "billing",
                status: Number(this.isInvoice),
                start: this._now().toFormat(this._getLuxonFormat()),
                source: ""
            };

            let promises = [self.getProviders()];
            if (self.isInvoice || (self.estimate && self.estimate.client))
                promises.unshift(self.getPatients());
            this.getPrinterList();
            Promise.all(promises).then(async () => {
                // Set the patient based on latest invoice item // edit based on it`s patient
                let patientId = null;

                if (!self.isNew) {
                    patientId = self.invoiceItem.patient
                        ? self.invoiceItem.patient.id
                        : null;
                } else if (
                    !self.addNew &&
                    self.isInvoice &&
                    self.invoice.active_invoice_items &&
                    self.invoice.active_invoice_items.length > 0
                ) {
                    patientId =
                        self.invoice.active_invoice_items[
                            self.invoice.active_invoice_items.length - 1
                        ].patient_id;
                } else if (!self.addNew && !self.isInvoice) {
                    if (
                        self.estimate.active_estimate_items &&
                        self.estimate.active_estimate_items.length > 0
                    ) {
                        patientId =
                            self.estimate.active_estimate_items[
                                self.estimate.active_estimate_items.length - 1
                            ].patient_id;
                    } else if (self.estimate.default_patient_id) {
                        patientId = self.estimate.default_patient_id;
                    }
                }

                const patient = find(
                    self.patientOptions,
                    opt => opt.id == patientId
                );

                // Remove  self.data.patients = []; as it only relavent when using old param self.data.patient which the param has data from create-update invoiceItem
                if (patient && !(self.isDuplicate && self.isInvoice)) {
                    self.data.patients = [patient];
                    self.data.patientId = patientId;
                    await self.patientsChanged(self.data.patients);
                } else if (self.addNew) {
                    await self.patientsChanged(self.data.patients);
                }

                if (!self.isNew) {
                    self.editRecord();
                } else {
                    self.completedLoading();
                }
            });
        },
        completedLoading() {
            let self = this;
            self.$nextTick(async () => {
                self.isSkipWatch = false;
                self.removeLoadingItem("construct");
                self.isDataLoaded = true;
                await self.$nextTick();
                if (self.$refs["select-item"]) {
                    self.$refs["select-item"].focus();
                }
            });
        },
        async validate() {
            let validate = await this.$validator.validate();

            // VET-1217 - lab item cannot proceed if select clinic provider
            let isLabUseClinicProvider =
                (this.data.item_type == ITEMTYPES.TYPES.TYPE_LAB ||
                    this.data.item_type == ITEMTYPES.TYPES.TYPE_RADIOLOGY) &&
                this.data.provider &&
                this.data.provider.is_default_provider;

            if (isLabUseClinicProvider) {
                this.formError.push("provider");
                this.pushAlertMessages(
                    RecordHelper.LAB_USE_CLINIC_PROVIDER_MSG
                );
            }

            return (
                validate &&
                this.formError.length == 0 &&
                !isLabUseClinicProvider
            );
        },
        async editRecord() {
            let self = this;
            const data = await this.getInvoiceEstimateItemDetails(
                self.invoiceItem.id
            );

            if (!self.isInvoice) {
                if (
                    self.invoiceItem.bundle_id &&
                    self.invoiceItem.bundle_element_id
                ) {
                    const res = await TemplateService.getElementBundle(
                        self.invoiceItem.bundle_element_id
                    );

                    if (res && res.template) {
                        self.data.templateData = { ...res };
                        self.data.bundleType =
                            res.template.type ||
                            INVOICEITEM.BUNDLE_TYPE.INVOICE; // default to invoice type bundle
                    } else {
                        self._message(
                            "Unable to fetch template data.",
                            "warning"
                        );
                    }
                }
            }

            self.invoiceItem = merge(this.invoiceItem, data, {
                item_name: this.invoiceItem.item_name // item_name keep using from the old source
            });

            // self.getTaxFeeByItem(self.invoiceItem.item); // not in use because this.data.item would always be null
            self.getDiscountsByItem(self.invoiceItem.item_id);

            self.data.discountType = self.invoiceItem?.discount_type;
            self.data.item = self.invoiceItem.item;
            self.data.item.label = entities.decodeHTML(
                self.invoiceItem.item.name
            );
            self.data.item_type = self.invoiceItem.item.type;
            self.data.itemName = self.invoiceItem.item.name;
            self.data.quantity = self.isInvoice
                ? self.invoiceItem.quantity
                : self.invoiceItem.quantity_min;
            self.data.iitem_default_quantity = self.isInvoice
                ? self.invoiceItem.quantity
                : self.invoiceItem.quantity_min;
            self.data.minimum_price = self.isInvoice
                ? self.invoiceItem.minimum_price
                : self.invoiceItem.item.minimum_price;
            self.data.isPrintOnInvoice = self.isInvoice
                ? self.invoiceItem.print_on_invoice == 1
                : self.invoiceItem.print_on_estimate == 1;
            self.data.unitPrice = this._toNumber(
                self.data.isPrintOnInvoice == 1
                    ? self.invoiceItem.unit_price
                    : 0,
                2,
                false
            );
            self.data.total_item_price = this._toNumber(
                self.invoiceItem.total - self.invoiceItem.tax,
                2,
                false
            );

            if (self.isInvoice) {
                self.data.price_tier_id = self.invoiceItem.price_tier_id;
                if (self.data.price_tier_id || self.data.minimum_price) {
                    if (self.data.price_tier_id == -1) {
                        self.data.is_min_price_tier = 2;
                    } else {
                        self.data.is_min_price_tier = 1;
                    }
                }
            } else {
                self.data.price_tier_min_id =
                    self.invoiceItem.price_tier_min_id;
                self.data.price_tier_max_id =
                    self.invoiceItem.price_tier_max_id;

                if (
                    self.data.price_tier_min_id ||
                    self.data.price_tier_max_id ||
                    self.invoiceItem.is_min_price
                ) {
                    self.data.is_min_price_tier = self.invoiceItem.is_min_price;
                }
            }

            self.data.iitem_unit_price_ori = self.invoiceItem.unit_price;
            self.data.isHasRecordPage =
                self.invoiceItem.record != null
                    ? CREATERECORD
                    : DONTCREATERECORD;

            let iitem_fee_price = 0;
            self.invoiceItem.fees.map(fee => {
                if (fee.price) {
                    iitem_fee_price += fee.price;
                }
            });
            self.data.iitem_fee_price = iitem_fee_price;

            self.data.iitem_price = self.invoiceItem.price;
            self.data.iitem_default_item_price = self.invoiceItem.price;
            self.data.iitem_orig_item_price = self.invoiceItem.item.unit_price;

            self.data.minimum_price_type = self.invoiceItem.minimum_price_type;

            // start - use by estimate
            if (!this.isInvoice) {
                self.data.defaultIitemPid = self.invoiceItem.patient_id;
                self.data.minUnitPrice = parseFloat(
                    self.invoiceItem.unit_price_min
                ).toFixed(2);
                self.data.maxUnitPrice = parseFloat(
                    self.invoiceItem.unit_price_max
                ).toFixed(2);
                self.data.iitem_min_unit_price_ori =
                    self.invoiceItem.unit_price_min;
                self.data.iitem_max_unit_price_ori =
                    self.invoiceItem.unit_price_max;
                self.data.minQuantity = self.invoiceItem.quantity_min;
                self.data.maxQuantity =
                    self.invoiceItem.quantity_max != -1
                        ? self.invoiceItem.quantity_max
                        : null;
                self.data.defaultMinUnitPrice = self.data.iitem_orig_item_price;
                self.data.defaultMaxUnitPrice = self.data.iitem_orig_item_price;
                self.data.defaultMinUnitQuantity = self.minQuantity;
                self.data.defaultMaxUnitQuantity = self.maxQuantity;
                self.data.discountMin = self.invoiceItem.discount_min;
                self.data.discountMax = self.invoiceItem.discount_max;
                self.data.isCustomItemFromBundle = self.invoiceItem
                    .template_element
                    ? self.invoiceItem.template_element.is_custom_price
                    : null;

                // if (self.data.maxUnitPrice == 0) {
                //     this.debounceMaxUnitPrice(self.data.minUnitPrice);
                // }
                // if (
                //     self.data.maxQuantity == null ||
                //     self.data.maxQuantity == 0
                // ) {
                //     this.debounceMaxQuantity(self.data.minQuantity);
                // }
            }
            // end - use by estimate

            if (self.invoiceItem.item_uom) {
                self.data.uomLabel = self.invoiceItem.item_uom.value;
                self.data.uomId = self.invoiceItem.item_uom.id;
            }

            if (
                self.data.isPrintOnInvoice == 1 &&
                Array.isArray(self.invoiceItem.fees) &&
                self.invoiceItem.fees.length > 0
            ) {
                self.data.fees = filter(self.invoiceItem.fees, f => {
                    if (f.cost_plus_price) {
                        f.name = `${f.name} (${f.cost_plus_price.account_format})`;
                    }
                    return f.cost_plus_price && f.cost_plus_price.raw_value > 0;
                });
                self.data.iitem_item_fees = self.invoiceItem.fees;
            }

            let default_iitem_fee_price = 0;
            self.data.iitem_default_item_fees = Array.isArray(
                self.invoiceItem.item.fees
            )
                ? self.invoiceItem.item.fees.map(f => {
                      if (f.cost_plus_price) {
                          f.name += ` (${f.cost_plus_price.account_format})`;
                          default_iitem_fee_price +=
                              f.cost_plus_price.raw_value;
                      }
                      return f;
                  })
                : [];
            self.data.default_iitem_fee_price = default_iitem_fee_price;

            self.data.discountId = self.invoiceItem.discount_id;
            self.data.iitemWellnessId = this.invoiceItem.record_resource?.form_data?.invoice_item_resource?.WellnessPlanID;
            if (
                self.data.discountId &&
                ![
                    INVOICEITEM.DISCOUNTS.CUSTOM.id,
                    INVOICEITEM.DISCOUNTS.INVOICE.id,
                    INVOICEITEM.DISCOUNTS.WELLNESS.id
                ].includes(this.data.discountId)
            ) {
                // Specific Discount
                // The API calculate_discount will return the discount amount and type
            } else if (!isEmpty(self.data.iitemWellnessId)) {
                // Wellness plan
                self.data.discountId = INVOICEITEM.DISCOUNTS.WELLNESS.id;
            } else if (
                self.data.discountId == null ||
                self.data.discountId == INVOICEITEM.DISCOUNTS.CUSTOM.id
            ) {
                // Custom and if no discount
                self.data.discountId = INVOICEITEM.DISCOUNTS.CUSTOM.id;
                self.data.discountAmount = this._toNumber(
                    self.invoiceItem.discount,
                    2,
                    false
                );
                self.data.discountType = self.invoiceItem.discount_type || 0;
            }

            // forlab
            self.checkImageTypeFields();

            if (
                self.invoiceItem?.record_resource &&
                this.isLabItem &&
                !this.isDuplicate
            ) {
                self.applyLot(self.invoiceItem.record_resource, false);
                // self.getInventoryLot(self.data.item.id, false);
            }

            let taxesExists = false;
            if (this.isInvoice) {
                taxesExists =
                    Array.isArray(self.invoiceItem.taxes) &&
                    self.invoiceItem.taxes.length > 0;
            } else {
                taxesExists =
                    Array.isArray(self.invoiceItem.taxes_min) &&
                    self.invoiceItem.taxes_min.length > 0;
            }
            if (
                !this.isExcludedFromTaxes &&
                taxesExists &&
                self.$refs.vetSelectTaxes
            ) {
                let filterTaxes =
                    self.invoiceItem.taxes || self.invoiceItem.taxes_min;
                self.data.taxes = filter(filterTaxes, tax => tax.value !== "");
            }

            this.data.isShowPrinter =
                [
                    ITEMTYPES.TYPES.TYPE_OTHER_FEES,
                    ITEMTYPES.TYPES.TYPE_LAB
                ].includes(self.invoiceItem.item.type) &&
                self.data.isHasRecordPage == CREATERECORD;

            if (this.data.isShowPrinter) {
                this.setPrinterLabel(this.data.item.print_label);
            }

            // FOR WELLNESS
            if (self.isInvoice && self.invoiceItem.check_wellness_plan) {
                self.data.is_plan_item =
                    self.invoiceItem.check_wellness_plan.is_plan_item;
                self.data.plan_item_balance =
                    self.invoiceItem.check_wellness_plan.balance;
                self.data.is_non_plan_item =
                    self.invoiceItem.check_wellness_plan.is_non_plan_item;
                self.data.is_plan_active =
                    self.invoiceItem.check_wellness_plan.is_plan_active;
                self.data.non_plan_discount =
                    self.invoiceItem.check_wellness_plan.non_plan_disc;
            }

            this.isInvoice
                ? await this.calculateDiscountAndTotalPrice(false)
                : await this.calculateDiscountAndTotalPriceEstimate(false);
            await this.update_discount_field(
                self.invoiceItem,
                self.data.discountId
            );

            // For edit invoice item and applied only to wellness plan
            if (self.data.is_plan_item) {
                self.data.total_item_price = self.invoiceItem.item_price;
            }

            // the code put here after all the calculation to prevent the warning message been removed
            if (this.isExcludedFromTaxes) {
                this.pushAlertMessages(CLIENT_IS_TAXEXEMPT_MSG);
            }

            if (this.isDuplicate) {
                this.getItemActions(self.invoiceItem.item_id);
            }

            self.completedLoading();
        },
        async getItemActions(itemId) {
            this.data.action = [];
            ItemActionService.getActions(itemId).then(response => {
                if (response.length > 0) {
                    this.addActions(response, true);
                }
            });
        },
        getDiscountsByItem(itemId) {
            let self = this;
            return ItemDiscountService.getItemDiscounts(itemId).then(function (
                response
            ) {
                if (response) {
                    self.data.applicableDiscountsId = filter(
                        response,
                        res => res.is_applicable == 1
                    )[0].id;
                    self.discountOptions = union(
                        filter(response, res => res.is_applicable == 1)
                    ).concat(self.discountOptions);
                }
            });
        },
        getProviders() {
            let self = this;

            StaffService.getProviders().then(response => {
                if (response.resource && response.resource.data) {
                    self.providers = response.resource.data.map(provider => {
                        provider.actor.name = provider.actor.label;
                        provider.actor.is_default_provider =
                            provider.is_default_provider;
                        return provider.actor;
                    });
                    self.providers = sortBy(self.providers, ["name"]);
                    self.setDefaultStaffId(self.providers);
                }
            });
        },
        setDefaultStaffId(providerOptions) {
            let self = this;
            let currentStaff = find(providerOptions, [
                "id",
                self.$root.currentActor.id
            ]);

            if (!self.isNew) {
                if (self.invoiceItem.provider) {
                    self.invoiceItem.provider.name =
                        self.invoiceItem.provider.label;
                    self.data.provider = self.invoiceItem.provider;
                } else if (self.invoiceItem.default_provider) {
                    // for estimate endpoint, response has different structure with invoice as default_provider.label is undefined
                    if (
                        !self.invoiceItem.default_provider.label &&
                        self.invoiceItem.default_provider.business
                    ) {
                        self.invoiceItem.default_provider.name =
                            self.invoiceItem.default_provider.business.name +
                            " Provider";
                    } else {
                        self.invoiceItem.default_provider.name =
                            self.invoiceItem.default_provider.label;
                    }
                    self.data.provider = self.invoiceItem.default_provider;
                }
            } else if (!self.addNew || (self.addNew && !self.data.provider)) {
                // for add new, will proceed with the existing provider

                // BASED ON CI, set provider is setted based on
                // 1. If invoice has invoice items, set the new item provider based on previous invoice item provider
                // 2. else check default provider
                // 3. else current user as a provider
                // 4. else only 1 provider, so set it as the provider
                // 5. else let it empty

                // VET-1217
                const defaultClinicProvider = find(providerOptions, [
                    "is_default_provider",
                    true
                ]);

                let activeItemsExist = this.isInvoice
                    ? self.invoice.active_invoice_items &&
                      self.invoice.active_invoice_items.length > 0
                    : self.estimate.active_estimate_items &&
                      self.estimate.active_estimate_items.length > 0;

                if (activeItemsExist) {
                    let prescribedBy = this.isInvoice
                        ? self.invoice.active_invoice_items[
                              self.invoice.active_invoice_items.length - 1
                          ].prescribed_by
                        : self.estimate.active_estimate_items[
                              self.estimate.active_estimate_items.length - 1
                          ].prescribed_by;
                    const previousProvider = find(providerOptions, [
                        "id",
                        prescribedBy
                    ]);

                    if (previousProvider) {
                        self.data.provider = previousProvider;
                    }
                } else if (defaultClinicProvider && !currentStaff) {
                    self.data.provider = defaultClinicProvider;
                } else if (providerOptions.length > 0 && currentStaff) {
                    // when currentActor is a provider, then default for provider and givenBy will auto select the currentActor
                    self.data.provider = currentStaff;
                } else if (providerOptions.length == 1) {
                    // default the provider if only 1 provider exists
                    self.data.provider = providerOptions[0];
                }

                if (!self.isInvoice) {
                    let estimateHasProvider;

                    if (self.estimate.default_provider_id === null) {
                        estimateHasProvider = false;
                    } else {
                        estimateHasProvider = !this.checkNullCharsUnicode(
                            self.estimate.default_provider_id
                        );
                    }

                    // reset value provider for estimate only
                    if (estimateHasProvider && !activeItemsExist) {
                        // use provider selected from create new estimate modal
                        const defaultProvider = find(providerOptions, [
                            "id",
                            self.estimate.default_provider_id
                        ]);
                        self.data.provider = defaultProvider;
                    } else if (!activeItemsExist && !defaultClinicProvider) {
                        self.data.provider = null;
                    }
                }
            }
        },
        /**
         * Used from record.js (mixin)
         */
        getStaffList(source) {
            let self = this;
            let lab_source = "";
            if (
                source === "ZNLABS" ||
                source === "VETEK" ||
                source === "MICROVET" ||
                source === "BIONOTE"
            ) {
                self.data.staff_id = "";
                lab_source = "&source=" + source;
            }
            self.data.provider = null;
            self.providers = [];
            return this.$http
                .get(
                    process.env.APPS +
                        "index.php/ajax/staff/filter_administrator_veterinarian_sql?search_key=" +
                        lab_source
                )
                .then(function (response) {
                    if (response.data) {
                        self.providers = response.data;
                        self.providers = sortBy(self.providers, ["name"]);
                        self.setDefaultStaffId(self.providers);
                        return self.providers;
                    }
                });
        },
        async reset() {
            // @see apps/application/controllers/billing/item.php@1720
            let self = this;
            self.isSkipWatch = true;
            self.$validator.reset();
            // other will be reset except patient, givenDate (in create-update) and provider
            self.data = Object.assign({}, await INITIAL_DATA(), {
                SOAPS: self.data.soaps,
                patients: self.data.patients,
                patientId: self.data.patientId,
                provider: self.data.provider,
                isMultiplePatient: self.data.isMultiplePatient
            });
            self.checkImageTypeFields();
        },
        getLatestVital(patientId) {
            this.weight = DEFAULT_WEIGHT;
            PatientService.getLatestVital(patientId).then(res => {
                if (res && res.resources) {
                    let weight = find(res.resources, { master_vital_id: 4 });
                    let patientWeight = weight
                        ? { weight: weight.value, uom: weight.master_uom_id }
                        : DEFAULT_WEIGHT;

                    if (!this.data.isMultiplePatient) {
                        this.weight = patientWeight;
                    }

                    let patientIndex = findIndex(this.data.patients, {
                        id: patientId
                    });

                    // The dosage component use weightData prop to do the calculation but it only handles single patient
                    // So by adding prop patients, we may handle multiple patients
                    if (patientIndex !== -1) {
                        this.data.patients[patientIndex].weight = patientWeight;
                    }
                }
            });
        },
        async getItemDetails(itemID) {
            const response = await ItemService.getItemDetails(itemID, {
                encoded: false,
                with_item_dosage: false,
                filter_transactions: true
            });
            return response;
        },
        validateUnitPrice() {
            let unitPriceMin = parseFloat(this.data.minUnitPrice);
            let unitPriceMax = parseFloat(this.data.maxUnitPrice);
            //validate min & max unit price
            if (
                unitPriceMin > unitPriceMax &&
                !this.isPriceTier &&
                unitPriceMax != 0
            ) {
                this.pushAlertMessages(
                    INVOICEITEM.ALERT_MESSAGE
                        .LOW_UNIT_PRICE_VALUE_LOWER_THAN_HIGH
                );
                this.canProceed = false;
            } else {
                if (
                    this.alertMessages.includes(
                        INVOICEITEM.ALERT_MESSAGE
                            .LOW_UNIT_PRICE_VALUE_LOWER_THAN_HIGH
                    )
                ) {
                    this.removeAlertMessages(
                        INVOICEITEM.ALERT_MESSAGE
                            .LOW_UNIT_PRICE_VALUE_LOWER_THAN_HIGH
                    );
                }
                this.canProceed = true;
            }
        },
        checkToShowWellnessMessage() {
            if (this.hasPatientWellnessPlan) {
                this.hideUnitPrice = WELLNESSPLAN_PATIENT_MSG_FOR_UNIT_PRICE;
                this.pushAlertMessages(WELLNESSPLAN_PATIENTS_MSG);
            } else {
                this.hideUnitPrice = "";
                this.removeAlertMessages(WELLNESSPLAN_PATIENTS_MSG);
            }
        }
    }
};
</script>
<style scoped>
.treeselect-opt-margin {
    margin-bottom: 2px;
}
</style>
